import { render, staticRenderFns } from "./individus-card.vue?vue&type=template&id=25fb08b2&scoped=true&"
import script from "./individus-card.vue?vue&type=script&lang=ts&"
export * from "./individus-card.vue?vue&type=script&lang=ts&"
import style0 from "./individus-card.vue?vue&type=style&index=0&id=25fb08b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fb08b2",
  null
  
)

export default component.exports